exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-input-container{width:100%;}\n.outer_width{width:900px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/pay-balance-admin/pay-balance-admin.component.css
// module id = ../../../../../src/app/admin/pay-balance-admin/pay-balance-admin.component.css
// module chunks = 39